// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"A8-z"};